import React from 'react';
import { Layout, Typography, Card, Table, Tag, Space, Button, Divider, List } from 'antd';
import { ArrowLeftOutlined, CalculatorOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import LayoutComponent from './Layout';

const { Title, Text, Paragraph } = Typography;

const VariablesInfoPage = () => {
    const navigate = useNavigate();

    // Данные для таблицы входных полей
    const inputFields = [
        { key: '1', field: '<Doroga_do_obiekta_(minut)>', desc: 'Время в пути до объекта (мин)' },
        { key: '2', field: '<Doroga_s_obiekta_(minut)>', desc: 'Время в пути с объекта (мин)' },
        { key: '3', field: '<Vremja_na_rabote>', desc: 'Чистое время выполнения работ (мин)' },
        { key: '4', field: '<Probeg,_km>', desc: 'Пробег автомобиля за задачу (км)' },
        { key: '5', field: '<CHase_dizelenija>', desc: 'Время работы дизель-генератора (мин)' },
        { key: '6', field: '**fuel_consumption**', desc: 'Норма расхода топлива (из карточки контрагента)' },
    ];

    // Обновленная логика расчетов (арифметическое округление, 2 знака)
    const calculationLogic = [
        {
            name: 'время_в_дороге',
            formula: '(Туда + Обратно) / 60',
            rounding: 'Арифметическое до 2-х знаков',
            code: 'Math.round(((roadTo + roadFrom) / 60) * 100) / 100'
        },
        {
            name: 'общее_время',
            formula: '(Туда + Обратно + Работа) / 60',
            rounding: 'Арифметическое до 2-х знаков',
            code: 'Math.round(((roadTo + roadFrom + workMin) / 60) * 100) / 100'
        },
        {
            name: 'затрачено_топлива_на_авто',
            formula: '(Пробег * Расход) / 100',
            rounding: 'Арифметическое до 2-х знаков',
            code: 'Math.round(((mileageKm * fuelCons) / 100) * 100) / 100'
        },
        {
            name: 'время_дизеления',
            formula: 'Дизеление (мин) / 60',
            rounding: 'Арифметическое до 2-х знаков',
            code: 'Math.round((dieselMinutes / 60) * 100) / 100'
        },
        {
            name: 'время_дизеления_минус1',
            formula: 'время_дизеления - 1 час',
            rounding: 'Не может быть меньше 0',
            code: 'Math.max(Math.round((dieselHours - 1) * 100) / 100, 0)'
        },
        {
            name: 'генерация',
            formula: 'время_дизеления + время_в_дороге',
            rounding: 'Арифметическое до 2-х знаков',
            code: 'Math.round(((dieselMin / 60) + travelTimeHours) * 100) / 100'
        }
    ];

    return (
        <LayoutComponent>
            <div style={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    
                    {/* Шапка */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <Button 
                            icon={<ArrowLeftOutlined />} 
                            onClick={() => navigate('/dashboard')} 
                            type="text" 
                        />
                        <Title level={2} style={{ margin: 0 }}>Справочник вычисляемых переменных</Title>
                    </div>

                    <Paragraph>
                        Эти переменные доступны в шаблонах ВДР и автоматически рассчитываются системой 
                        на основе данных из кастомных полей задачи в Geofam.
                    </Paragraph>

                    {/* Таблица входных данных */}
                    <Card title={<><InfoCircleOutlined /> Входные данные (Метрики из задачи)</>} bordered={false}>
                        <Table 
                            dataSource={inputFields} 
                            pagination={false} 
                            size="small"
                            columns={[
                                { title: 'Плейсхолдер', dataIndex: 'field', key: 'field', render: text => <Tag color="blue">{text}</Tag> },
                                { title: 'Описание', dataIndex: 'desc', key: 'desc' },
                            ]}
                        />
                    </Card>

                    <Divider>Алгоритмы расчета</Divider>

                    {/* Сетка карточек с формулами */}
                    <List
                        grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 3 }}
                        dataSource={calculationLogic}
                        renderItem={item => (
                            <List.Item>
                                <Card 
                                    title={<Text strong style={{color: '#1890ff'}}>${item.name}$</Text>}
                                    size="small"
                                    hoverable
                                    actions={[<CalculatorOutlined key="calc" />]}
                                >
                                    <Paragraph style={{ marginBottom: 8 }}>
                                        <Text type="secondary" size="small">Логика:</Text><br />
                                        <Text code>{item.formula}</Text>
                                    </Paragraph>
                                    <Paragraph style={{ marginBottom: 8 }}>
                                        <Text type="secondary" size="small">Округление:</Text><br />
                                        <Text italic>{item.rounding}</Text>
                                    </Paragraph>
                                    <div style={{ background: '#f5f5f5', padding: '8px', borderRadius: '4px' }}>
                                        <Text style={{ fontSize: '11px', fontFamily: 'monospace' }}>{item.code}</Text>
                                    </div>
                                </Card>
                            </List.Item>
                        )}
                    />

                    
                </Space>
            </div>
        </LayoutComponent>
    );
};

export default VariablesInfoPage;